import { render, staticRenderFns } from "./PurchaseRows.vue?vue&type=template&id=006d7bb2&scoped=true"
import script from "./PurchaseRows.vue?vue&type=script&lang=js"
export * from "./PurchaseRows.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRows.vue?vue&type=style&index=0&id=006d7bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d7bb2",
  null
  
)

export default component.exports